import React, { useState, useEffect } from 'react';
import { db, storage } from '../../utils/firebase'; // Assuming the firebase.js file is in the same directory
import { collection, getDocs } from 'firebase/firestore';
import { ref, getDownloadURL } from 'firebase/storage';
import './Delicacies.css'; // Import your updated CSS file

const Delicacies = () => {
  const [delicacies, setDelicacies] = useState([]);
  
  useEffect(() => {
    const fetchDelicacies = async () => {
      try {
       
        const querySnapshot = await getDocs(collection(db, 'delicacies'));
        const fetchedDelicacies = [];
        
      
        for (const doc of querySnapshot.docs) {
          const data = doc.data();
          const imageRef = ref(storage, data.images_1);
          
          
          const imageUrl = await getDownloadURL(imageRef);
          
     
          fetchedDelicacies.push({
            name: data.title,
            image: imageUrl,
            description: data.description,
            price: data.price,
            whereToBuy: data.where_to_buy,
          });
        }

        setDelicacies(fetchedDelicacies); 
      } catch (error) {
        console.error('Error fetching delicacies: ', error);
      }
    };

    fetchDelicacies();
  }, []); 

  return (
    <div className="delicacies-container">
      <h2 className="delicacies-title">Bacoor's Native Delicacies</h2>
      <p className="delicacies-description">
        Discover the rich and flavorful treats that Bacoor has to offer. 
      </p>

      <div className="delicacies-grid">
        {delicacies.map((delicacy, index) => (
          <div className="delicacy-card" key={index}>
            <div className="delicacy-image-wrapper">
              <img
                src={delicacy.image}
                alt={delicacy.name}
                className="delicacy-image"
              />
              <div className="delicacy-info">
                <h3>{delicacy.name}</h3>
                <p>{delicacy.description}</p>
                <p><strong>Price: </strong>{delicacy.price}</p>
                <p><strong>Where to buy: </strong>{delicacy.whereToBuy}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Delicacies;
